import IntentPage from './IntentPage'
export default IntentPage
